import { useAppDispatch, useAppSelector } from "@builder/store/store";
import "./style.scss";
import { setConditionalVariationMode } from "@builder/store/slices/BuilderSlice/builderSlice";
import { getCurrentLayer } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { useEffect, useState } from "react";

interface ConditionalVariationMenuProps {
    id: string;
    amount: number;
}

const ConditionalVariationMenu = ({ id, amount }: ConditionalVariationMenuProps) => {
    const [parentDimensions, setParentDimensions] = useState<{ width: number; height: number } | null>(null);
    const dispatch = useAppDispatch();

    const handleClick = () => {
        dispatch(setConditionalVariationMode({ id, index: 0, parentDimensions }));
    };

    const currentLayer = useAppSelector(getCurrentLayer);
    const variationNode = currentLayer?.components[id];
    const parentNode = currentLayer?.components[variationNode?.parent as string];

    useEffect(() => {
        if (parentNode) {
            const parentNodeElem = document.getElementById(parentNode.id);
            if (parentNodeElem) {
                setParentDimensions({ width: parentNodeElem.clientWidth, height: parentNodeElem.clientHeight });
            } else {
                setParentDimensions(null);
            }
        } else {
            setParentDimensions(null);
        }
    }, [parentNode]);

    return (
        <button className="conditional-variation-menu" onClick={handleClick}>
            <img src={`/fork.svg`} alt="Conditional Variation Menu" />
            {amount}
        </button>
    );
};

export default ConditionalVariationMenu;
